import type {
  LeagueNextTarget,
  LeagueSummary,
  LeagueZone,
} from "@core/league/types";

export type LeagueHomeModel =
  | { kind: "hidden" }
  | { kind: "noGrade" }
  | { kind: "closing" }
  | { kind: "start"; monthParticipants: number }
  | {
      kind: "ranked";
      monthRank: number | null;
      monthParticipants: number;
      zone: LeagueZone | null;
      nextTarget: LeagueNextTarget | null;
      pendingReveals: number;
    };

/**
 * Decide what the home card shows from the `?view=card` summary. Renders
 * nothing when League is off for the channel or the data is unusable.
 */
export function buildLeagueHomeModel(
  summary: LeagueSummary | null | undefined,
  leagueFeatureOn: boolean,
): LeagueHomeModel {
  if (!leagueFeatureOn || !summary || !summary.enabled || summary.state === "off") {
    return { kind: "hidden" };
  }

  if (summary.state === "noGrade") return { kind: "noGrade" };
  if (summary.state === "weekClosing") return { kind: "closing" };
  if (!summary.week) return { kind: "hidden" };

  const monthParticipants = summary.month?.participants ?? 0;
  const enrolled =
    summary.state === "active" ||
    (summary.state !== "notEnrolled" && summary.week.enrolled);

  if (!enrolled && summary.month?.rank == null) {
    return { kind: "start", monthParticipants };
  }

  return {
    kind: "ranked",
    monthRank: summary.month?.rank ?? null,
    monthParticipants,
    zone: summary.week.zone,
    nextTarget: summary.week.nextTarget,
    pendingReveals: summary.pendingRevealCount,
  };
}
